import { Entry } from "contentful";
import {
  ContentBlock,
  FlowContainer,
  GuideContainer,
  GuideTypes,
  Metadata,
} from "../models";
import { UserContextValues } from "../types";
import { createGuide } from "./GuideFactory";

export const createFlowContainer = (
  entries: Entry<ContentBlock & Metadata>[],
  guideTypes: GuideTypes[],
  userContextValues?: UserContextValues,
): FlowContainer => {
  const guides: GuideContainer[] = [];
  guideTypes.forEach(guideType => {
    const guide = createGuide(entries, guideType, userContextValues);
    if (guide.introHeader?.title && guide.content && guide.content?.length > 0) {
      guides.push({...guide, guideType});
    }
  });

  return {
    guides,
  };
};
